import { Component, computed, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DrawerModule } from 'primeng/drawer';
import { LayoutService } from '@/app/layout/service/layout.service';
import { AuthService } from '@/app/core/auth/auth.service';

@Component({
    selector: '[app-profilesidebar]',
    imports: [ButtonModule, DrawerModule],
    template: `
        <p-drawer
            [visible]="visible()"
            (onHide)="onDrawerHide()"
            position="right"
            [transitionOptions]="'.3s cubic-bezier(0, 0, 0.2, 1)'"
            styleClass="layout-profile-sidebar w-full sm:w-25rem"
        >
            <div class="flex flex-col">
                <span class="mb-2 font-semibold">Bienvenido</span>
                <span class="text-surface-900 dark:text-surface-0 font-medium">{{ adminName() }}</span>
                <span class="text-surface-500 dark:text-surface-400 text-sm mb-8">{{ adminEmail() }}</span>

                <ul class="list-none m-0 p-0">
                    <li>
                        <a
                            (click)="onLogout()"
                            class="cursor-pointer flex p-4 items-center border border-surface-200 dark:border-surface-700 rounded hover:bg-surface-100 dark:hover:bg-surface-800 transition-colors duration-150"
                        >
                            <span>
                                <i class="pi pi-power-off text-xl text-primary"></i>
                            </span>
                            <div class="ml-4">
                                <span class="mb-2 font-semibold">Cerrar sesión</span>
                                <p class="text-surface-500 dark:text-surface-400 m-0">Salir del backoffice</p>
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
        </p-drawer>
    `
})
export class AppProfileSidebar {
    private layoutService = inject(LayoutService);
    private auth = inject(AuthService);

    visible = computed(() => !!this.layoutService.layoutState().profileSidebarVisible);
    adminName = computed(() => this.auth.currentAdmin()?.name ?? '—');
    adminEmail = computed(() => this.auth.currentAdmin()?.email ?? '');

    // Promise resolver para coordinar logout con el cierre real del drawer.
    // PrimeNG dispara (onHide) recién cuando la animación termina; usar ese
    // evento evita un setTimeout arbitrario y deja el cleanup del mask antes
    // de que el router desmonte AppLayout.
    private onDrawerFullyClosed: (() => void) | null = null;

    onDrawerHide() {
        this.layoutService.layoutState.update((state) => ({
            ...state,
            profileSidebarVisible: false
        }));
        const cb = this.onDrawerFullyClosed;
        this.onDrawerFullyClosed = null;
        cb?.();
    }

    async onLogout() {
        if (this.visible()) {
            await new Promise<void>((resolve) => {
                this.onDrawerFullyClosed = resolve;
                this.layoutService.layoutState.update((s) => ({ ...s, profileSidebarVisible: false }));
                // Safety: si por alguna razón onHide no dispara, no quedar colgado.
                setTimeout(() => {
                    if (this.onDrawerFullyClosed === resolve) {
                        this.onDrawerFullyClosed = null;
                        resolve();
                    }
                }, 1000);
            });
        }
        await this.auth.logout();
    }
}
